import { useTranslation } from "react-i18next";

import { RestrictedAccessScreen } from "@dashboard/library";

export function ForbiddenErrorScreen() {
  const { t } = useTranslation();

  return (
    <RestrictedAccessScreen
      title={t("error_screen.403.title")}
      subtitle={t("error_screen.403.message")}
      data-test="forbidden-error-screen"
    />
  );
}
